<template>
  <div class="mymapBody" id="map">
    <div class="mapTitleBox">场馆地图</div>
    <div class="showAllpalce">
      <van-search v-model="value" @focus="geotoHomePge" placeholder="搜索场馆" />
    </div>
  </div>
</template>

<script>
import { MapCreate } from "../map/mapImport";
import mymarker from "../assets/marker.png";
export default {
  data() {
    return {
      map: null,
      value: "",
      placeList: [
        {
          name: "北京故宫博物馆",
          lat: "39.916351",
          lon: "116.397041",
          imgurl: require("../assets/fhobnjtvfckx1hz2t8bq.jpg")
        },
        {
          name: "北京体育馆",
          lat: "39.881775",
          lon: "116.422049",
          imgurl: require("../assets/images.jpg")
        },
        {
          name: "北京动物园",
          lat: "39.94",
          lon: "116.34",
          imgurl: require("../assets/images2.jpg")
        },
        {
          name: "北京冬奥公园",
          lat: "39.90",
          lon: "116.16",
          imgurl: require("../assets/5f60a29af26e41edaf0f982923350fafFOoS_s.jpg")
        }
      ]
    };
  },
  mounted() {
    this.map = new MapCreate();
    this.map.init("map");
    this.showMapMarker();
  },
  methods: {
    geotoHomePge(){
      this.$router.push('/home')
    },
    gotodelpage(){
      this.$router.push('/introduce')
    },
    showMapMarker() {
        let that = this
        this.map.map.on("popupopen", function() {
          document.getElementById("btn").onclick = function() {
           
            that.gotodelpage(); // 跳转到详情页面的方法
          };
        });
      this.placeList.map(item => {
        // console.log(item);
        let greenIcon = L.icon({
          iconUrl: item.imgurl,

          iconSize: [30, 30] // size of the icon
        });
        let markerDjc = L.marker([item.lat, item.lon], {
          icon: greenIcon
        }).addTo(this.map.map);
      

        markerDjc.on("click", () => {
          L.popup()
            .setLatLng([item.lat, item.lon])
            .setContent(
              `
              <p>场馆名称：${item.name}</p>
              <p>开放时间：周一到周日，10:00-18:00</p>
              <p>联系电话：182XXXXXXXX</p>
              <div class='myopobtn' id='btn' >查看详情</div>

            `
            )
            .openOn(this.map.map);
        });
        L.DomUtil.addClass(markerDjc._icon, "blinking");
      });
    }
  }
};
</script>

<style>
.mymapBody {
  height: 100vh;
  width: 100vw;
  background-color: aquamarine;
}
.mapTitleBox {
  height: 30px;
  width: 80%;
  position: absolute;
  top: 0px;
  left: 10vw;
  z-index: 999;
  /* background-color: red; */
  text-align: center;
  line-height: 30px;
  font-size: 20px;
}
.showAllpalce {
  width: 80vw;

  /* height: 40px; */
  /* background-color: white; */
  position: absolute;
  z-index: 999;
  top: 30px;
  right: 10vw;
  color: white;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
@keyframes wxBlinking {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
.blinking {
  animation: wxBlinking 1s infinite alternate;
}
.myopobtn {
  /* background-color: red; */
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>